
import React, { Component, useState, useEffect } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './PreviewPageEditor.css';
import { accountId } from '../../config';

import {
    message
} from 'antd';

import {
    previewGet,
    previewCreateOrUpdate
} from '../../modules/shortenLink';

const { ContentImage } = require(`../../modules/api/${accountId}_contentApi`);

const DraggableButton = React.forwardRef(({ button, updateButton, bgImageUrl }, ref) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'BUTTON',
        item: { id: 'button', initialPosition: { ...button.position } },
        collect: (monitor) => ({ isDragging: !!monitor.isDragging() }),
    }), [button.position]); // Add button.position as a dependency

    const [, drop] = useDrop(() => ({
        accept: 'BUTTON',
        drop: (item, monitor) => {
            const delta = monitor.getDifferenceFromInitialOffset();
            if (delta) {
                const newPosition = {
                    x: Math.max(0, item.initialPosition.x + delta.x),
                    y: Math.max(0, item.initialPosition.y + delta.y)
                };
                updateButton({ position: newPosition });
                item.initialPosition = newPosition;
            }
        },
    }));

    return (
        <div
            ref={drop}
            style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                backgroundImage: bgImageUrl ? `url(${bgImageUrl})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            <div
                ref={drag}
                style={{
                    position: 'absolute',
                    left: `${button.position.x}px`,
                    top: `${button.position.y}px`,
                    opacity: isDragging ? 0.5 : 1,
                    cursor: 'move',
                }}
            >
                <button
                    style={{
                        padding: '10px 20px',
                        fontSize: '16px',
                        borderRadius: '8px',
                        backgroundColor: button.color,
                        color: 'white',
                        border: 'none'
                    }}
                >
                    {button.text}
                </button>
            </div>
        </div>
    );
});

class PreviewPageEditor extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
        this.state = {
            bgImageUrl: props.initialData?.bgImageUrl || '',
            button: {
                text: 'Open App',
                position: {
                    x: 100,
                    y: 300,
                },
                color: '#007BFF'
            },
            title: props.initialData?.title || 'Preview Page',
            description: props.initialData?.description || 'This is a preview page',
            previewDataRes: null
        };
    }

    updateButton = (newProps) => {
        this.setState((prevState) => ({
            button: { ...prevState.button, ...newProps },
        }));
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        }, () => {
            this.forceUpdate();
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { onSubmit, initialValues } = this.props;

        const previewData = {
            linkId: initialValues._id,
            bgImageUrl: this.state.bgImageUrl,
            button: this.state.button,
            title: this.state.title,
            description: this.state.description,
        };

        this.props.previewCreateOrUpdate(previewData)
            .then(() => {
                message.success('Preview page updated successfully');
                onSubmit(previewData);
            })
            .catch(error => {
                if (error.response && error.response.data) {
                    console.log('CAMPAIGN', error.response.data);
                }
                message.error(error.response.data.message);
            });
    };

    render() {

        const { bgImageUrl, button, title, description, previewDataRes } = this.state;

        return (
            <div className="preview-page-editor">
                <h2>Edit Preview Page</h2>
                <form onSubmit={this.handleSubmit}>
                    <div className="editor-container">
                        {/* left side area */}
                        <div className="preview-section">
                            <div className="phone-frame">
                                <DndProvider backend={HTML5Backend}>
                                    <DraggableButton
                                        ref={this.buttonRef}
                                        button={button}
                                        updateButton={this.updateButton}
                                        bgImageUrl={bgImageUrl || ''}
                                    />
                                </DndProvider>
                            </div>
                        </div>

                        {/* Right side area */}
                        <div className="settings-section">
                            {/* <div className="form-group">
                                <label htmlFor="title">Title</label>
                                <input
                                    type="text"
                                    id="title"
                                    name="title"
                                    value={title}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="description">Description</label>
                                <textarea
                                    id="description"
                                    name="description"
                                    value={description}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                />
                            </div> */}

                            <div className="form-group">
                                <label htmlFor="bgImageUrl">Background Image URL</label>
                                <input
                                    type="text"
                                    id="bgImageUrl"
                                    name="bgImageUrl"
                                    value={bgImageUrl}
                                    onChange={this.handleInputChange}
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group">
                                <label>Button Position</label>
                                <div className="position-controls">
                                    <p>X: {button.position.x}px</p>
                                    <p>Y: {button.position.y}px</p>
                                </div>
                                <p className="help-text">Drag the button in the preview to adjust position</p>
                            </div>

                            <div className="form-group">
                                <label htmlFor="buttonText">Button Text</label>
                                <input
                                    type="text"
                                    id="buttonText"
                                    name="buttonText"
                                    value={button.text}
                                    onChange={(e) => this.updateButton({ text: e.target.value })}
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="buttonColor">Button Color</label>
                                <input
                                    type="color"
                                    id="buttonColor"
                                    name="buttonColor"
                                    value={button.color}
                                    onChange={(e) => this.updateButton({ color: e.target.value })}
                                    className="form-control"
                                    style={{ width: '100px', height: '25px', padding: '0' }}
                                />
                            </div>

                            <div className="form-actions">
                                <button type="submit" className="btn-save">{previewDataRes ? 'Update' : 'Save'} </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }


    parseLink = (link) => {
        try {
            const url = new URL(link);
            const params = new URLSearchParams(url.search);

            const contentType = params.get('contentType') || undefined;
            const contentId = params.get('contentId') || undefined;
            const action = params.get('action') || undefined;
            const episodeId = params.get('episodeId') || undefined;

            return {
                contentType,
                contentId,
                action,
                episodeId,
            };
        } catch (error) {
            console.error('Error parsing link:', error);
            return {};
        }
    };

    componentDidMount() {

        const { initialValues } = this.props;
        if (initialValues) {
            const { link, ...rest } = initialValues;
            const parsedValues = this.parseLink(link);
            this.setState({ parsedValues }, () => {
                this.fetchInitialData();
            });
        }
    }

    fetchInitialData = async () => {

        this.setState({ loading: true });
        const { initialValues } = this.props;
        this.props.previewGet(initialValues._id).then(res => {
            this.afterFetchPreviewData(res);
            this.setState({ loading: false });
        }).catch(error => {
            this.afterFetchPreviewData(null);
            this.setState({ loading: false });
        });

    };

    afterFetchPreviewData = async (previewData) => {
        try {
            if (!previewData) {
                const { contentId, contentType } = this.state.parsedValues || {};
                if (!contentId || !contentType) return;
                const responseImage = await ContentImage.getPortrait(contentId, contentType);
                if (!responseImage) return;
                this.setState({
                    bgImageUrl: responseImage
                });
            } else {
                this.setState({
                    bgImageUrl: previewData.bgImageUrl,
                    button: {
                        text: previewData.button.text,
                        position: previewData.button.position,
                        color: previewData.button.color
                    },
                    title: previewData.title,
                    description: previewData.description,
                    previewDataRes: previewData
                });
            }
        } catch (error) {
            console.error('Failed to fetch initial data:', error);
        }
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            previewGet,
            previewCreateOrUpdate
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewPageEditor);


